import script from "./my-home.vue?vue&type=script&setup=true&lang=js"
export * from "./my-home.vue?vue&type=script&setup=true&lang=js"

import "./my-home.vue?vue&type=style&index=0&id=3bda8ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bda8ba0"]])

export default __exports__